<template>
  <label>Select tip %</label>
  <div class="percentage-panel">
    <template v-for="percentage in [5, 10, 15, 25, 50]" :key="percentage">
      <percentage-button
        :percentage="percentage"
        v-model.number="currentPercentage"
        :disabled="disabledButtons"
      />
    </template>
    <input
      type="number"
      name=""
      class="custom-input"
      placeholder="Custom"
      min="1"
      v-model.number="customPercentage"
    />
  </div>
</template>

<script lang="ts">
import store from '@/store';
import { SET_TIP_PERCENTAGE } from '@/store/mutations';
import { defineComponent } from 'vue';
import PercentageButton from './PercentageButton.vue';
export default defineComponent({
  name: 'the-calculator-percentage-panel',
  components: { PercentageButton },
  data() {
    return {
      currentPercentage: 0,
      customPercentage: '',
      disabledButtons: false,
      unwatch: () => {
        return;
      },
    };
  },
  watch: {
    customPercentage() {
      if (
        typeof this.customPercentage !== 'string' &&
        this.customPercentage > 0
      ) {
        this.disabledButtons = true;
        this.currentPercentage = 0;
        store.commit(SET_TIP_PERCENTAGE, { value: this.customPercentage });
      } else {
        this.disabledButtons = false;
      }
    },
    currentPercentage() {
      store.commit(SET_TIP_PERCENTAGE, { value: this.currentPercentage });
    },
  },
  created() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.isStateEmpty,
      (newValue) => {
        if (newValue) {
          this.currentPercentage = 0;
          this.disabledButtons = false;
        }
      },
    );
  },
  beforeUnmount() {
    this.unwatch();
  },
});
</script>

<style lang="scss" scoped>
.percentage-panel {
  display: grid;
  grid-template-columns: repeat(3, 8rem);
  gap: 0.5rem;
  margin-top: 0.75rem;

  @include phone-styles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.custom-input {
  align-self: stretch;
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  text-align: right;
  color: $darkest-cyan;
  font-weight: 700;
  font-family: inherit;

  border: 0.2rem solid transparent;
  outline: none;
  border-radius: 0.3rem;
  background-color: $ligher-cyan;

  padding: 0 0.5rem;

  transition: all 0.2s;

  &:focus {
    &:valid {
      border-color: $primary-cyan;
    }

    &:invalid {
      border-color: $error-red;
    }
  }

  &::placeholder {
    text-align: center;
    color: $darker-cyan;
    font-weight: 700;
    font-family: inherit;
  }
}
</style>
